<template>
  <div
    class="d-flex pa-2 flex-row flex-wrap"
    :style="{ height: 'fit-content' }"
  >
    <card-row :title="'Search'" :cardColor="'white'" :displayed="true">
      <div style="width: 100%">
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              id="promo_name"
              ref="promo_name"
              :search-input.sync="searchPromo"
              v-model="searchData.promo_name"
              :items="promoList"
              hide-selected
              label="Nama Promo"
              persistent-hint
              item-text="promo_name"
              item-value="id"
              :loading="loadingPromoList"
              hint="Search by MID"
              hide-details="true"
              dense
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="searchData.mid_bank"
              type="text"
              label="MID"
              hide-details="true"
              dense
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="searchData.mpan"
              type="text"
              label="MPAN"
              hide-details="true"
              dense
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="searchData.rrn"
              type="text"
              label="Reff ID"
              hide-details="true"
              dense
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="searchData.customer_pan"
              type="text"
              label="CPAN"
              hide-details="true"
              dense
            />
          </v-col>
          <v-col cols="12" sm="6" md="9">
            <v-dialog
              ref="rangeDateDialog"
              v-model="rangeDateDialog"
              :return-value.sync="searchData.trx_date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  id="rangeDate"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  v-model="dateRangeText"
                  label="Transaction Date"
                  hide-details="true"
                  dense
                />
              </template>
              <v-date-picker
                v-model="searchData.trx_date"
                scrollable
                range
                :max="getTommorowDate(0)"
              >
                <v-spacer />
                <v-btn text color="accent" @click="rangeDateDialog = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="accent"
                  @click="
                    () => {
                      checkRangeDate(searchData.trx_date);
                      $refs.rangeDateDialog.save(searchData.trx_date);
                    }
                  "
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row class="d-flex align-center justify-left">
          <v-col cols="12">
            <v-btn
              color="primary"
              @click.stop="getData"
              :disabled="loadingPromoList"
              :loading="loading"
              >search</v-btn
            >
          </v-col>
        </v-row>
      </div>
    </card-row>
  </div>
</template>

<script>
import {
  dataListMerchantCriteria,
  dataListAccountStatus,
  dataQrType,
  dataSettlementTypeItems,
} from '../../store/params';
import { date, getTommorowDate } from '../../lib/helpers';

export default {
  components: { CardRow: () => import('../CardRow.vue') },
  props: ['search', 'loading'],
  data: () => ({
    loadingPromoList: false,
    listMerchantCriteria: dataListMerchantCriteria,
    listAccountStatus: dataListAccountStatus,
    listQrType: dataQrType,
    settlementTypeItems: dataSettlementTypeItems,
    rangeDateDialog: false,
    rangeDateDialogInactive: false,
    searchPromo: '',

    searchPromoList: { promo_name: '' },
  }),
  watch: {
    searchPromo(val) {
      if (val && val.length >= 3) {
        this.searchPromoList.promo_name = val;
        this.getPromoList();
      } else {
        this.searchData.promo_name = '';
        this.searchPromoList.promo_name = '';
        this.$store.commit('reportPromo/clearDataPromo');
      }
    },
  },
  computed: {
    searchData: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
    dateRangeText() {
      return this.searchData.trx_date.join(' ~ ');
    },
    promoList() {
      return this.$store.state.reportPromo.promoList;
    },
  },
  methods: {
    getPromoList() {
      this.loadingPromoList = true;
      this.$store.commit('reportPromo/setFlashErrorMessage', '');
      this.$store
        .dispatch('reportPromo/getPromoList', {
          date,
          sortBy: 'ID ASC',
          search: this.searchPromoList,
        })
        .finally(() => {
          this.loadingPromoList = false;
        });
    },

    checkRangeDate(trx_date) {
      trx_date.sort();
      if (trx_date.length == 1) {
        trx_date.push(this.searchData.trx_date[0]);
      }
    },

    clearSearch() {
      this.$emit('clearSearchParent');
    },
    getData() {
      this.$emit('getDataParent');
    },
    getTommorowDate,
  },
};
</script>
